import {useUser} from "../../../Context/UserContext";
import ResultView from "../../V2/ResultView";
import {MessageCodes} from "../MessageCodes";
import ResultText from "../ResultText";
import ResultTable from "../../Table/ResultTable";
import ResultHeader from "../../Table/ResultHeader";
import ResultRow from "../../Table/ResultRow";
import ResultHeaderCell from "../../Table/ResultHeaderCell";
import ResultBodyCell from "../../Table/ResultBodyCell";
import CheckCSName from "../../CheckCSName";
import ResultBody from "../../Table/ResultBody";
import HecRasHelper from "../../../Helpers/HecRasHelper";
import ResultCellHighlight from "../../Table/ResultCellHighlight";

export default function SV1({data, message_key}) {
    const {settings} = useUser()

    return (
        <>
            {
                data?.result?.map(row => (
                    <ResultView error_id={row?.error_id} message_key={message_key}>
                        <Description row={row} settings={settings} globalVariables={data?.global_variables} />
                    </ResultView>
                ))
            }
        </>
    )
}

function Description({row, settings, globalVariables}) {
    switch (row.error_id) {
        case MessageCodes.Internal.SV1_SV01.error_id: {
            return (
                <ResultText>
                    The culvert invert elevations are not consistent with the survey data at the following {row?.data?.length} culverts.
                    <ResultTable maxWidth={HecRasHelper.getWidth(60)}>
                        <ResultHeader>
                            <ResultRow>
                                <ResultHeaderCell rowSpan={2} style={{width: HecRasHelper.getWidth(20), textAlign: 'left'}}>Culvert</ResultHeaderCell>
                                <ResultHeaderCell colSpan={2} style={{width: HecRasHelper.getWidth(20)}}>US</ResultHeaderCell>
                                <ResultHeaderCell colSpan={2} style={{width: HecRasHelper.getWidth(20)}}>DS</ResultHeaderCell>
                            </ResultRow>
                            <ResultRow>
                                <ResultHeaderCell style={{width: HecRasHelper.getWidth(10), textAlign: 'right'}}>Survey</ResultHeaderCell>
                                <ResultHeaderCell style={{width: HecRasHelper.getWidth(10), textAlign: 'right'}}>Model</ResultHeaderCell>
                                <ResultHeaderCell style={{width: HecRasHelper.getWidth(10), textAlign: 'right'}}>Survey</ResultHeaderCell>
                                <ResultHeaderCell style={{width: HecRasHelper.getWidth(10), textAlign: 'right'}}>Model</ResultHeaderCell>
                            </ResultRow>
                        </ResultHeader>
                        <ResultBody>
                            {
                                row?.data?.map(r => {

                                    return (
                                        <ResultRow>
                                            <ResultBodyCell style={{width: HecRasHelper.getWidth(20), textAlign: 'left'}}>
                                                Culvert {r?.culvert_num} RS <CheckCSName csName={r?.cross_section} />
                                            </ResultBodyCell>
                                            <ResultBodyCell style={{width: HecRasHelper.getWidth(10), textAlign: 'right'}}>{r?.survey_us?.toFixed(2)}</ResultBodyCell>
                                            <ResultBodyCell style={{width: HecRasHelper.getWidth(10), textAlign: 'right'}}>
                                                {ResultCellHighlight(r?.survey_us?.toFixed(2), r?.culv_us?.toFixed(2))}
                                            </ResultBodyCell>
                                            <ResultBodyCell style={{width: HecRasHelper.getWidth(10), textAlign: 'right'}}>{r?.survey_ds?.toFixed(2)}</ResultBodyCell>
                                            <ResultBodyCell style={{width: HecRasHelper.getWidth(10), textAlign: 'right'}}>
                                                {ResultCellHighlight(r?.survey_ds?.toFixed(2), r?.culv_ds?.toFixed(2))}
                                            </ResultBodyCell>
                                        </ResultRow>
                                    )
                                })
                            }
                        </ResultBody>
                    </ResultTable>
                </ResultText>
            )
        }
    }
}